import React from 'react';
import useStyles from './Footer.styles';
import { getLabel } from '../../../helpers/labels';

const HELP_URL =
  'https://outlook.office.com/mail/deeplink/compose?to=sjo.deskbooksupport@vml.com';

const Footer: React.FC = () => {
  const classes = useStyles();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={classes.root}>
      <a href={HELP_URL} target="_blank" rel="noopener noreferrer" className={classes.helpLink}>
        {getLabel('footerNeedHelp')}
      </a>
      <span className={classes.copyright}>
        &copy; {currentYear} {getLabel('footerCopyright')}
      </span>
    </footer>
  );
};

export default Footer;
